export const STR_APP_NAME = {
  en: "AGENTIKA",
  sw: "AGENTIKA",
};

export const STR_HEALTH = {
  en: "health",
  sw: "afya",
}

export const STR_RELATIONSHIPS = {
  en: "relationships",
  sw: "mahusiano",
}

export const STR_STORIES = {
  en: "stories",
  sw: "masimulizi",
}

export const STR_COURSES = {
  en: "Courses",
  sw: "Kozi",
}


export const STR_GET_STARTED = {
  en: "get started",
  sw: "anza sasa",
}

export const STR_CONTINUE = {
  en: "continue",
  sw: "endelea",
}

export const STR_ENTER = {
  en: "enter",
  sw: "ingia",
}

export const STR_ENTER_YOUR_PHONE_NUMBER = {
  en: "Enter your phone number",
  sw: "Ingiza namba yako ya simu",
}

export const STR_PHONE_NUMBER = {
  en: "Phone number",
  sw: "Namba ya simu",
}

export const STR_ENTER_OTP = {
  en: "Enter the OTP sent to your phone",
  sw: "Ingiza OTP uliotumiwa kwenye simu",
}

export const STR_PLEASE_WAIT = {
  en: "Please wait..",
  sw: "Tafadhali subiri..",
}

export const STR_INVALID_PHONE = {
  en: "Invalid phone number",
  sw: "Namba ya simu sio sahihi",
}

export const STR_INVALID_OTP = {
  en: "Invalid OTP",
  sw: "OTP sio sahihi",
}

export const STR_WELCOME = {
  en: "Welcome..",
  sw: "Karibu..",
}

export const STR_CHANGE_PHONE = {
  en: "Change Phone",
  sw: "Badili Simu",
}

export const STR_RESEND_OTP = {
  en: "Resend OTP",
  sw: "Tuma tena OTP",
}

export const STR_MENU_HOME = {
  en: "Home",
  sw: "Nyumbani",
}

export const STR_MENU_DATING = {
  en: "Dating",
  sw: "Mahusiano",
}

export const STR_MENU_DOCTORS = {
  en: "Doctors",
  sw: "Madaktari",
}

export const STR_MENU_INBOX = {
  en: "Inbox",
  sw: "Ujumbe",
}

export const STR_MENU_ARTICLES = {
  en: "Articles",
  sw: "Makala",
}

export const STR_MENU_STORIES = {
  en: "Stories",
  sw: "Simulizi",
}

export const STR_MENU_UTILITIES = {
  en: "Utilities",
  sw: "Visaidizi",
}

export const STR_LATEST_ARTICLES = {
  en: "Latest Articles",
  sw: "Makala Mpya",
}

export const STR_MORE_ARTICLES = {
  en: "More Articles",
  sw: "Makala Zaidi",
}

export const STR_LATEST_STORIES = {
  en: "Latest Stories",
  sw: "Simulizi Mpya",
}

export const STR_LATEST_COURSES = {
  en: "Latest Courses",
  sw: "Kozi Mpya",
}

export const STR_MORE_STORIES = {
  en: "More Stories",
  sw: "Simulizi Zaidi",
}

export const STR_MORE_COURSES = {
  en: "More Courses",
  sw: "Kozi Zaidi",
}

export const STR_PERSONAL_SETTINGS = {
  en: "Personal Settings",
  sw: "Mipangilio Binafsi",
}

export const STR_UPDATE_USERNAME = {
  en: "Update username",
  sw: "Badili/Weka jina",
}

export const STR_CHANGE_PHONE_NUMBER = {
  en: "Change phone number",
  sw: "Badili namba ya simu",
}

export const STR_UPDATE_PERSONAL_INFO = {
  en: "Update personal information",
  sw: "Badili/Weka taarifa binafsi",
}

export const STR_PAYMENT_SETTINGS = {
  en: "Payments",
  sw: "Malipo",
}

export const STR_SUBSCRIPTION_FEE_PAYMENTS = {
  en: "My Subscription",
  sw: "Kifurushi cha matumizi",
}

export const STR_CONSULTATION_FEE_PAYMENTS = {
  en: "Doctor's consultation fee payment",
  sw: "Malipo ya kuwasiliana na daktari",
}

export const STR_MY_SUBSCRIPTION = {
  en: "My Subscription",
  sw: "Kifurushi cha matumizi",
}

export const STR_SUBSCRIPTION_HAS_EXPIRED = {
  en: "Subscription has expired",
  sw: "Kifurushi kimeisha",
}

export const STR_PURCHASE_SUBSCRIPTION_PACKAGE = {
  en: "Purchase a subscription package to enjoy all features in this app",
  sw: "Nunua kifurushi cha matumizi ili kufurahia kila kitu kwenye App hii",
}

export const STR_SELECT = {
  en: "Select",
  sw: "Chagua",
}

export const STR_COMPLETE_PAYMENT = {
  en: "Complete Payment",
  sw: "Kamilisha Malipo",
}

export const STR_PAY_WITH_CARD = {
  en: "Pay with Credit Card",
  sw: "Lipia kwa Kadi",
}

export const STR_PAY_WITH_MOBILE = {
  en: "Pay with Mobile Network",
  sw: "Lipia kwa Mtandao wa Simu",
}

export const STR_SELECT_PAYMENT_METHOD = {
  en: "Select payment method",
  sw: "Chagua njia ya kufanya malipo",
}

export const STR_ENTER_PHONE_NUMBER_FOR_PAYMENT = {
  en: "Enter phone number you want to use for this payment. All Tanzanian networks are supported.",
  sw: "Ingiza namba ya simu utakayofanyia malipo. Tunapokea kutoka mitandao yote ya Tanzania",
}

export const STR_FINALIZE_PAYMENT_CARD = {
  en: "Please wait, you'll soon be redirected to complete the payment with your card.",
  sw: "Tafadhali subiri utaelekezwa kwenye kiungo cha kufanyia malipo kwa kadi yako",
}

export const STR_FINALIZE_PAYMENT_MOBILE = {
  en: "Push USSD was sent to your phone please check and finalize the payment",
  sw: "Tafadhali angalia simu yako ili kukamilisha malipo kwa USSD Push",
}

export const STR_BUY_NOW = {
  en: "Buy Now",
  sw: "Nunua Sasa",
}

export const STR_DAYS = {
  en: "Days",
  sw: "Siku",
}

export const STR_FROM = {
  en: "From",
  sw: "Kuanzia",
}

export const STR_TO = {
  en: "To",
  sw: "Hadi",
}

export const STR_PRICE = {
  en: "Price in TZS",
  sw: "Bei kwa TZS",
}

export const STR_PASSWORD = {
  en: "Password",
  sw: "Nenosiri",
}

export const STR_CONFIRM = {
  en: "Confirm",
  sw: "Hakiki",
}

export const STR_INVALID_PASSWORD = {
  en: "Invalid Password, password must have atleast 8 characters",
  sw: "Nenosiri angalau liwe na muunganiko wa namba na herufi angalau 8",
}

export const STR_INVALID_CONFIRM_PASSWORD = {
  en: "Please confirm your password correctly",
  sw: "Tafadhali hakiki nenosiri lako kwa usahihi",
}

export const STR_CHANGE_LANGUAGE = {
  en: "Tumia Swahili",
  sw: "Change to English",
}

export const STR_FORGOT_PASSWORD = {
  en: "Forgot Password",
  sw: "Nimesahau Nenosiri",
}

export const STR_NO = {
  en: "No",
  sw: "Hapana",
}

export const STR_YES = {
  en: "Yes",
  sw: "Ndio",
}

export const STR_BOND_CALCULATOR = {
  en: "Bonds Calculator",
  sw: "Kikokotozi Hatifungani",
}

export const STR_LOAN_CALCULATOR = {
  en: "Loans Calculator",
  sw: "Kikokotozi Mikopo",
}

export const STR_UTT_CALCULATOR = {
  en: "UTT AMIS Calculators",
  sw: "Vikokotozi vya UTT AMIS",
}

export const STR_BOOKS_LIBRARY = {
  en: "Books' Library",
  sw: "Maktaba ya Vitabu",
}

export const STR_INTRO_1 = {
  en: "LandLink Hub",
  sw: "LandLink Hub",
}

export const STR_POWERED_BY = {
  en: "Powered By KAMOLA GEOSERVICES LTD",
  sw: "Imeletwa na KAMOLA GEOSERVICES LTD",
}

export const STR_INTRO_2 = {
  en: "Map Land, Verify it, Own it.",
  sw: "Pima Ardhi, Ithibitishe, Imiliki",
}

export const STR_TRACK = {
  en: "Track",
  sw: "Fuatilia",
}

export const STR_LEARN = {
  en: "Learn",
  sw: "Jifunze",
}

export const STR_ACCOUNT = {
  en: "Account",
  sw: "Akaunti",
}

export const STR_INCOME = {
  en: "Income",
  sw: "Kipato",
}

export const STR_SAVINGS = {
  en: "Savings",
  sw: "Akiba",
}

export const STR_EXPENSES = {
  en: "Expenses",
  sw: "Matumizi",
}

export const STR_DEBTS = {
  en: "Debts",
  sw: "Madeni",
}

export const STR_CHARITY = {
  en: "Charity",
  sw: "Matoleo",
}

export const STR_INVESTMENTS = {
  en: "Investments",
  sw: "Uwekezaji",
}

export const STR_INSURANCE = {
  en: "Insurance",
  sw: "Bima",
}

export const STR_VIEW_MORE = {
  en: "View More...",
  sw: "Ona Zaidi...",
}

export const STR_TOTAL = {
  en: "Total",
  sw: "Jumla",
}

export const STR_RECORD = {
  en: "Record",
  sw: "Rekodi",
}

export const STR_SET_GOAL = {
  en: "Set Goal",
  sw: "Weka Lengo",
}

export const STR_RECORD_INCOME = {
  en: "Record Income",
  sw: "Rekodi Kipato",
}

export const STR_DESCRIPTON = {
  en: "Description",
  sw: "Maelezo",
}

export const STR_AMOUNT = {
  en: "Amount (in TZS)",
  sw: "Kiasi (kwa TZS)",
}

export const STR_DATE = {
  en: "Date",
  sw: "Tarehe",
}

export const STR_CATEGORY = {
  en: "Category",
  sw: "Aina",
}

export const STR_OPTIONAL = {
  en: "Optional",
  sw: "Sio lazima",
}

export const STR_SUBMIT = {
  en: "Submit",
  sw: "Wasilisha",
}

export const STR_INVALID_AMOUNT = {
  en: "Invalid Amount",
  sw: "Kiasi sio sahihi",
}

export const STR_INVALID_DATE = {
  en: "Invalid date",
  sw: "Tarehe sio sahihi",
}

export const STR_INVALID_CATEGORY = {
  en: "Invalid category",
  sw: "Aina sio sahihi",
}

export const STR_SUCCESS = {
  en: "Succcessful",
  sw: "Imefanikiwa",
}

export const STR_HISTORY = {
  en: "History",
  sw: "Historia",
}

export const STR_GOALS = {
  en: "Goals",
  sw: "Malengo",
}

export const STR_PERIOD_ALL_TIME = {
  en: "All time",
  sw: "Muda wote",
}

export const STR_PERIOD_WEEK = {
  en: "This week",
  sw: "Wiki hii",
}

export const STR_PERIOD_MONTH = {
  en: "This month",
  sw: "Mwezi huu",
}

export const STR_NO_RECORD = {
  en: "No record",
  sw: "Hakuna taarifa kwa sasa",
}

export const STR_UPDATE = {
  en: "Edit",
  sw: "Hariri",
}

export const STR_RECORD_SAVINGS = {
  en: "Record Savings",
  sw: "Rekodi Akiba",
}

export const STR_RECORD_EXPENSES = {
  en: "Record Expenses",
  sw: "Rekodi Matumizi",
}

export const STR_RECORD_CHARITY = {
  en: "Record Charity",
  sw: "Rekodi Matoleo",
}

export const STR_RECORD_INVESTMENT = {
  en: "Record Investment",
  sw: "Rekodi Uwekezaji",
}

export const STR_RECORD_INSURANCE = {
  en: "Record Insurance",
  sw: "Rekodi Bima",
}

export const STR_RECORD_DEBT = {
  en: "Record Debt",
  sw: "Rekodi Deni",
}

export const STR_CANNOT_PROCESS_REQUEST = {
  en: "Cannot process request",
  sw: "Haiwezi kukamilisha ombi lako kwa sasa",
}

export const STR_OPERATION_FAILED = {
  en: "Operation failed",
  sw: "Imeshindwa kuendelea",
}

export const STR_PROJECTIONS = {
  en: "Projections",
  sw: "Matarajio",
}

export const STR_CREATE_NEW_GOAL = {
  en: "Create New Goal",
  sw: "Weka Lengo Jipya",
}

export const STR_START_DATE = {
  en: "Start Date",
  sw: "Tarehe ya kuanza",
}

export const STR_END_DATE = {
  en: "End Date",
  sw: "Tarehe ya kumaliza",
}

export const STR_INVALID_START_DATE = {
  en: "Invalid Start date",
  sw: "Tarehe ya kuanzia sio sahihi",
}

export const STR_INVALID_END_DATE = {
  en: "Invalid end date",
  sw: "Tarehe ya kumalizia sio sahihi",
}

export const STR_NOT_EDITABLE_WARN = {
  en: "You won't be able to edit details after creating",
  sw: "Hautoweza kuhariri taarifa baada ya kutengeneza",
}

export const STR_TARGET = {
  en: "Target",
  sw: "Lengo",
}

export const STR_ACTUAL = {
  en: "Actual",
  sw: "Halisi",
}

export const STR_DELETE_GOAL = {
  en: "Delete this goal",
  sw: "Futa lengo hili",
}

export const STR_DELETE = {
  en: "Delete",
  sw: "Futa",
}

export const STR_PROJECTIONS_INTO_TEXT = {
  en: "These projections assume that you continue with your current progress in the selected factor for a selected period",
  sw: "Makadirio haya ni endapo ukiendeleza utaratibu ulionao kwenye nguzo husika ndani ya kipindi ulichochagua",
}

export const STR_AMOUNT_PER_DAY = {
  en: "Amount per Day",
  sw: "Kiasi kwa Siku",
}

export const STR_TOTAL_AMOUNT = {
  en: "Total Amount",
  sw: "Jumla",
}

export const STR_TOTAL_EXPECTED_AMOUNT = {
  en: "Total Expected Amount",
  sw: "Jumla Inayotegemewa",
}

export const STR_SELECT_PERIOD = {
  en: "Select Period",
  sw: "Chagua kipindi",
}

export const STR_AFTER_ONE_MONTH = {
  en: "After One Month",
  sw: "Baada ya Mwezi Mmoja",
}

export const STR_AFTER_ONE_WEEK = {
  en: "After One Week",
  sw: "Baada ya Wiki Moja",
}


export const STR_AFTER_6_MONTHS = {
  en: "After Six Months",
  sw: "Baada ya Miezi Sita",
}

export const STR_AFTER_ONE_YEAR = {
  en: "After One Year",
  sw: "Baada ya Mwaka Mmoja",
}

export const STR_AFTER_TWO_YEARS = {
  en: "After Two Years",
  sw: "Baada ya Miaka Miwili",
}

export const STR_AFTER_FIVE_YEARS = {
  en: "After Five Years",
  sw: "Baada ya Miaka Mitano",
}

export const STR_LEARN_MORE = {
  en: "Learn More...",
  sw: "Mafunzo Zaidi...",
}

export const STR_CALCULATORS = {
  en: "Calculators",
  sw: "Vikokotozi",
}

export const STR_CONTACT_US = {
  en: "Contact Us",
  sw: "Wasiliana Nasi",
}

export const STR_INTEREST_RATE = {
  en: "Annual Interest Rate",
  sw: "Kiwango cha Riba kwa mwaka",
};

export const STR_LOAN_TERM = {
  en: "Loan Term",
  sw: "Muda wa Mkopo",
};

export const STR_MONTHLY_PAYMENT = {
  en: "Monthly Payment",
  sw: "Marejesho ya Kila Mwezi",
};

export const STR_TOTAL_INTEREST = {
  en: "Total Interest",
  sw: "Jumla ya Riba",
};

export const STR_TOTAL_PAYMENT = {
  en: "Total Payment",
  sw: "Jumla ya Malipo",
};

export const STR_INVALID_INTEREST_RATE = {
  en: "Invalid interest rate",
  sw: "Kiwango cha riba sio sahihi",
};

export const STR_INVALID_LOAN_TERM = {
  en: "Invalid loan term",
  sw: "Muda wa mkopo sio sahihi",
};


export const STR_CALCULATE = {
  en: "Calculate",
  sw: "Kokotoa",
};

export const STR_IN_PERCENT = {
  en: "In Percentage (%)",
  sw: "Kwa asilimia (%)",
}

export const STR_IN_MONTHS = {
  en: "In Months",
  sw: "Kwa miezi",
}

export const STR_TERM_TYPE = {
  en: "Loan Term Type",
  sw: "Aina ya Muda wa Mkopo",
};

export const STR_SELECT_TERM_TYPE = {
  months: {
    en: "Months",
    sw: "Miezi",
  },
  years: {
    en: "Years",
    sw: "Miaka",
  },
};

export const STR_PAYMENT_FREQUENCY = {
  en: "Payment Frequency",
  sw: "Utaratibu wa Malipo",
};

export const STR_SELECT_FREQUENCY = {
  monthly: {
    en: "Monthly",
    sw: "Kila Mwezi",
  },
  quarterly: {
    en: "Quarterly",
    sw: "Kila Robo Mwaka",
  },
  annually: {
    en: "Annually",
    sw: "Kila Mwaka",
  },
};

export const STR_REPAYMENT = {
  en: "Payment",
  sw: "Rejesho",
}


export const STR_BOND_TERM = {
  en: "Bond Term (years)",
  sw: "Muda wa Kuiva (miaka)",
};

export const STR_ANNUAL_COUPON_PAYMENT = {
  en: "Coupon Payment",
  sw: "Malipo",
};

export const STR_TOTAL_COUPON_PAYMENT = {
  en: "Total Coupon Payment",
  sw: "Jumla ya Malipo",
};


export const STR_INVALID_BOND_TERM = {
  en: "Invalid bond term",
  sw: "Muda wa deni usiofaa",
};

export const STR_UTT_MONTHLY_INVESTMENT_CALC = {
  en: "UTT Monthly Investment Calculator",
  sw: "UTT: Kokotoa Uwekezaji wa Kila Mwezi",
}

export const STR_UTT_SINGLE_SUM_INVESTMENT_CALC = {
  en: "UTT Single Sum Investment Calculator",
  sw: "UTT: Kokotoa Uwekezaji wa Mara moja usiojirudia",
}

export const STR_EMAIL = {
  en: "Email Address",
  sw: "Anwani ya Barua pepe",
}

export const STR_INVALID_EMAIL = {
  en: "Invalid email",
  sw: "Anwani ya barua pepe sio sahihi",
}

export const STR_NOTIFICATIONS = {
  en: "Notifications",
  sw: "Taarifa",
}

export const STR_USE_EMAIL = {
  en: "Use Email",
  sw: "Barua Pepe",
}

export const STR_USE_PHONE = {
  en: "Use Phone",
  sw: "Namba ya Simu",
}

export const STR_ENTER_EMAIL_ADDRESS = {
  en: "Enter your email address",
  sw: "Weka anwani yako ya barua pepe",
}


export const STR_LOGIN_TO_CONTINUE = {
  en: "Login to continue",
  sw: "Ingia ili kuendelea",
}

export const STR_LOGIN_NOW = {
  en: "Login now",
  sw: "Ingia Sasa",
}

export const STR_CHANGE = {
  en: "Change",
  sw: "Badili",
}

export const STR_MONTHLY_INVESTMENT = {
  en: "Monthly Investment",
  sw: "Uwekezaji wa Kila Mwezi",
};

export const STR_EXPECTED_RETURN = {
  en: "Expected Annual Return",
  sw: "Faida Inayotarajiwa Kila Mwaka",
};

export const STR_INVESTMENT_PERIOD = {
  en: "Investment Duration in Years",
  sw: "Kipindi cha Uwekezaji kwa Miaka",
};

export const STR_TOTAL_INVESTMENT = {
  en: "Total Investment",
  sw: "Jumla ya Uwekezaji",
};

export const STR_EXPECTED_AMOUNT = {
  en: "Expected Amount",
  sw: "Kiasi Kinachotarajiwa",
};

export const STR_WEALTH_GAIN = {
  en: "Wealth Gain",
  sw: "Faida Itakayopatikana",
};

export const STR_SINGLE_SUM_INVESTMENT = {
  en: "Single Sum Investment",
  sw: "Uwekezaji wa Mara Moja",
};

export const STR_ARTICLES = {
  en: "Articles on how to build wealth",
  sw: "Makala za namna ya kujijengea Utajiri",
}

export const STR_RECORD_REPAYMENT = {
  en: "Record Repayment",
  sw: "Rekodi Marejesho",
}

export const STR_RECORD_RETURNS = {
  en: "Record Returns",
  sw: "Rekodi faida ya uwekezaji",
}

export const STR_ORIGINAL_AMOUNT = {
  en: "Original Amount",
  sw: "Kiasi cha mwanzo",
}

export const STR_REPAYMENTS = {
  en: "Repayments",
  sw: "Marejesho",
}

export const STR_RETURNS = {
  en: "Returns",
  sw: "Faida kwenye uwekezaji",
}

export const STR_LOGOUT = {
  en: "Log Out",
  sw: "Ondoka Kwenye Akaunti",
}

export const STR_SET_CURRENCY = {
  en: "Set Currency",
  sw: "Panga Sarafu",
}


export const STR_SELECT_CURRENCY_TO_USE = {
  en: "Select currency to use",
  sw: "Chagua sarafu ya kutumia",
}

export const STR_INVALID_CURRENCY = {
  en: "Invalid currency",
  sw: "Sarafu sio sahihi",
}

export const STR_MY_COACH = {
  en: "My Coach",
  sw: "Kocha Wangu",
}

export const STR_ENTER_COACH_PHONE = {
  en: "Enter your coach's phone (with country code)",
  sw: "Ingiza namba ya simu ya kocha wako ikiwa na country code",
}

export const STR_ENTER_FULLNAME = {
  en: "Enter your name as recognized by this coach",
  sw: "Ingiza jina lako kama unavyotabulika kwa kocha huyu",
}

export const STR_INVALID_NAME = {
  en: "Invalid name",
  sw: "Jina sio sahihi",
}

export const STR_MY_STUDENTS = {
  en: "My Students",
  sw: "Wanafunzi wangu",
}

export const STR_USER_REPORT = {
  en: "Report",
  sw: "Ripoti",
}

export const STR_BREAKDOWN = {
  en: "Breakdown",
  sw: "Mchanganuo",
}

export const STR_MESSAGES = {
  en: "Messages",
  sw: "Ujumbe",
}

export const STR_CONTACTS = {
  en: "Contacts",
  sw: "Mawasiliano",
}

export const STR_INDIVIDUALS = {
  en: "Individuals",
  sw: "Mmoja Mmoja",
}

export const STR_GROUPS = {
  en: "Groups",
  sw: "Makundi",
}

export const STR_CREATE_NEW_CONTACT = {
  en: "Create New Contact",
  sw: "Unda Mawasiliano Mapya",
}

export const STR_NAME = {
  en: "Name",
  sw: "Jina",
}

export const STR_WHATSAPP_NUMBER = {
  en: "Whatsapp Number",
  sw: "Namba ya Whatsapp",
}

export const STR_INVALID_WHATSAPP_NUMBER = {
  en: "Invalid whatsapp number",
  sw: "Namba ya whatsapp sio sahihi",
}

export const STR_FILTER_BY_NAME_OR_PHONE = {
  en: "Filter by name or phone",
  sw: "Chambua kwa simu au jina",
}

export const STR_FILTER_BY_NAME = {
  en: "Filter by name",
  sw: "Chambua kwa jina",
}

export const STR_CREATE_NEW_CONTACT_GROUP = {
  en: "Create New Contact Group",
  sw: "Unda Kundi la Mawasiliano",
}

export const STR_CREATE_NEW = {
  en: "Create New",
  sw: "Unda Mpya",
}

export const STR_MESSAGE_TITLE = {
  en: "Message Title",
  sw: "Kichwa cha Ujumbe",
}

export const STR_INVALID_TITLE = {
  en: "Invalid title",
  sw: "Kichwa sio sahihi",
}

export const STR_MESSAGE_BODY = {
  en: "Message Body",
  sw: "Ujumbe",
}

export const STR_INVALID_BODY = {
  en: "Invalid body",
  sw: "Ujumbe sio sahihi",
}

export const STR_MESSAGE_TO_BE_SENT = {
  en: "Message to be sent. Use code <name> to dynamically include receiver's name",
  sw: "Ujumbe utakaotumwa. Tumia kodi <name> kuingiza jina la mpokeaji kiotomatiki",
}

export const STR_SEND = {
  en: "Send",
  sw: "Tuma",
}

export const STR_WHATSAPP_MESSAGE = {
  en: "WhatsApp Message",
  sw: "Ujumbe wa WhatsApp",
}

export const STR__NORMAL_SMS = {
  en: "Normal SMS",
  sw: "Ujumbe wa Kawaida",
}

export const STR_MESSAGE_TYPE = {
  en: "Message Type",
  sw: "Aina ya Ujumbe",
}

export const STR_SENDER_ID = {
  en: "Sender ID",
  sw: "ID ya Utumaji",
}

export const STR_IMAGE = {
  en: "Image",
  sw: "Picha",
}

export const STR_RECEPIENTS = {
  en: "Recepients",
  sw: "Wapokeaji",
}

export const STR_INVALID_RECEPIENTS = {
  en: "Invalid Recepients",
  sw: "Wapokeaji sio sahihi",
}

export const STR_INVALID_MESSAGE = {
  en: "Invalid Message",
  sw: "Ujumbe sio sahihi",
}

export const STR_EDIT = {
  en: "Edit",
  sw: "Hariri",
}

export const STR_ALL = {
  en: "All",
  sw: "Wote",
}

export const STR_SUCCESSFULLY_SENT = {
  en: "Successfully Sent",
  sw: "Waliotumiwa Kikamilifu",
}

export const STR_SEND_FAILED = {
  en: "Send Failed",
  sw: "Walioshindwa kutumiwa",
}

export const STR_VIEW_GROUP = {
  en: "View Group",
  sw: "Fungua Kundi",
}

export const STR_WHATSAPP_SETUP = {
  en: "WhatsApp Setup",
  sw: "Mipangilio ya WhatsApp",
}

export const STR_WHATSAPP_QR_HELPER = {
  en: "Open your WhatsApp APP, click 'Linked Devices' then scan this code below to integrate your WhatsApp Account",
  sw: "Fungua APP yako ya WhatsApp kisha bofya 'Linked Devices' na scan code hii hapo chini ili kuunga whatsapp yako",
}

export const STR_WHATSAPP_BOT_STATUS = {
  en: "WhatsApp Integration Status",
  sw: "Hali ya Kuunganishwa na WhatsApp",
}

export const STR_WHATSAPP_QR_LAST_UPDATED = {
  en: "QR code last updated",
  sw: "Mara ya mwisho kuunda QR code",
}

export const STR_SCHEDULE_MESSAGE = {
  en: "Schedule Message",
  sw: "Tuma Baadae",
}

export const STR_SCHEDULED_AT = {
  en: "Scheduled At",
  sw: "Muda wa Kutuma",
}

export const STR_INTEGRATE_NOW = {
  en: "Integrate Now",
  sw: "Unganisha Sasa",
}

export const STR_SUBSCRIPTION_TYPE = {
  en: "Subscription Type",
  sw: "Aina ya kifurushi",
}

export const STR_SUBSCRIPTION_AMOUNT = {
  en: "Quantity",
  sw: "Idadi",
}

export const STR_ENTER_DETAILS = {
  en: "Enter Details",
  sw: "Weka Taarifa",
}

export const STR_UPLOAD_FILE = {
  en: "Upload File",
  sw: "Pakia Faili",
}

export const STR_EXCEL_FILE_HELPER_TEXT = {
  en: "Upload excel file with columns in this order: Name, Phone number, Whatsapp number",
  sw: "Chagua faili la excel lenye mpangilio huu: Jina, Namba ya Simu, Namba ya Whatsapp",
}

export const STR_FILE = {
  en: "File",
  sw: "Faili",
}

export const STR_INVALID_FILE = {
  en: "Invalid File",
  sw: "Faili sio sahihi",
}

export const STR_YOUR_PHONE = {
  en: "Your Phone",
  sw: "Namba Yako ya Simu",
}

export const STR_YOUR_OTP_VERIFICATION = {
  en: "OTP Verification",
  sw: "Uthibitisho wa OTP",
}

export const STR_MENU_HOTELS = {
  en: "Hotels",
  sw: "Hoteli",
}

export const STR__MENU_BOOKINGS = {
  en: "Bookings",
  sw: "Oda Zangu",
}

export const STR_MENU_ACCOUNT = {
  en: "Account",
  sw: "Akaunti",
}

export const STR_AVAILABLE_HOTELS = {
  en: "Available Hotels",
  sw: "Hoteli Zilizopo",
}

export const STR_AVAILABLE_ROOMS = {
  en: "Available Rooms",
  sw: "Vyumba Vilivyopo",
}

export const STR_BOOK_NOW = {
  en: "Book Now",
  sw: "Fanya Booking Sasa",
}

export const STR_PER_DAY = {
  en: "Per Day",
  sw: "Kwa siku",
}

export const STR_ROOM = {
  en: "Room",
  sw: "Chumba",
}

export const STR_REQUEST_FLOAT = {
  en: "Request Float",
  sw: "Omba Froti",
}

export const STR_REQUEST_CASH = {
  en: "Request Cash",
  sw: "Omba Cash",
}

export const STR_REQUESTS_FEED = {
  en: "Agents' Requests Feed",
  sw: "Maombi ya Mawakala",
}

export const STR_INBOX = {
  en: "My Inbox",
  sw: "Jumbe Zangu",
}

export const STR_NEARBY_SUPER_AGENTS = {
  en: "Nearby SuperAgents",
  sw: "Mawakala wakuu",
}

export const STR_NEARBY_AGENTS = {
  en: "Nearby Agents",
  sw: "Mawakala Waliokaribu",
}

export const STR_REPORT_ANALYSIS = {
  en: "Reports & Analysis",
  sw: "Ripoti & Uchakataji",
}

export const STR_LEARN_2 = {
  en: "Learn",
  sw: "Jifunze",
}

export const STR_YOUR_PROFILE = {
  en: "Your Profile",
  sw: "Wasifu Wako",
}

export const STR_RECENT_REQUESTS = {
  en: "Recent Requests",
  sw: "Maombi ya hivi karibuni",
}

export const STR_EDIT_AGENT_PROFILE = {
  en: "Edit Agent Profile",
  sw: "Hariri Wasifu wa Kiwakala",
}

export const STR_REGION = {
  en: "Region",
  sw: "Mkoa",
}

export const STR_DISTRICT = {
  en: "District",
  sw: "Wilaya",
}

export const STR_WARD = {
  en: "Ward or Village",
  sw: "Kata au Kijiji",
}

export const STR_STREET = {
  en: "Street",
  sw: "Mtaa",
}

export const STR_PROVIDE_YOUR_ADDRESS = {
  en: "Provide Your Address",
  sw: "Tuambie Mahali Ulipo",
}

export const STR_AGENT_NAME = {
  en: "Agent's Name",
  sw: "Jina la Wakala",
}

export const STR_AGENT_TYPE = {
  en: "Agent Type",
  sw: "Aina ya Wakala",
}

export const STR_SUPER_AGENT = {
  en: "Super Agent",
  sw: "Wakala Mkuu",
}

export const STR_NORMAL_AGENT = {
  en: "Normal Agent",
  sw: "Wakala wa Kawaida",
}

export const STR_AGENT_LOCATION = {
  en: "Agent's Location",
  sw: "Mahala Wakala Alipo",
}

export const STR_TILL_NUMBERS = {
  en: "Till Numbers",
  sw: "Namba za Uwakala",
}

export const STR_TILL_TYPE = {
  en: "Till Type",
  sw: "Aina ya Huduma",
}

export const STR_TILL_NUMBER = {
  en: "Till Number",
  sw: "Namba ya Wakala",
}

export const STR_TILL_NAME = {
  en: "Till Name",
  sw: "Jina la Namba ya Wakala",
}

export const STR_COULD_NOT_FETCH_DATA = {
  en: "Could not fetch data",
  sw: "Imeshindwa kupakia taarifa",
}

export const STR_TIN_NUMBER = {
  en: "TIN Number",
  sw: "Namba ya TIN",
}

export const STR_ADD = {
  en: "Add",
  sw: "Ongeza",
}

export const STR_INVALID_AGENT_NAME = {
  en: "Invalid Agent name",
  sw: "Jina la wakala sio sahihi",
}

export const STR_INVALID_TIN_NUMBER = {
  en: "Invalid TIN Number",
  sw: "Namba ya TIN sio sahihi",
}

export const STR_INVALID_AGENT_TYPE = {
  en: "Invalid Agent Type",
  sw: "Aina ya wakala sio sahihi",
}

export const STR_INVALID_AGENT_LOCATION = {
  en: "Invalid Agent Location",
  sw: "Mahala alipo wakala sio sahihi",
}

export const STR_INVALID_AGENT_TILLS = {
  en: "Invalid Agent Tills",
  sw: "Namba za Till zimeingizwa kimakosa",
}

export const STR_REQUEST_FLOAT_CASH = {
  en: "Request Float or Cash",
  sw: "Omba Floti au Keshi",
}

export const STR_CASH = {
  en: "Cash",
  sw: "Keshi",
}

export const STR_FLOAT = {
  en: "Float",
  sw: "Floti",
}

export const STR_SELECT_2 = {
  en: "Select",
  sw: "Chagua",
}

export const STR_SERVICE_PROVIDER = {
  en: "Network or Bank",
  sw: "Mtandao au Bank",
}

export const STR_AMOUNT_2 = {
  en: "Amount in TZS",
  sw: "Kiasi kwa TZS",
}

export const STR_SELECT_REQUEST_TYPE = {
  en: "Select Request Type",
  sw: "Chagua aina ya Ombi",
}

export const STR_INVALID_SERVICE_PROVIDER = {
  en: "Invalid network or bank",
  sw: "Bank au Mtandao sio sahihi",
}

export const STR_REQUEST_AMOUNT_LIMIT = {
  en: "Minimum is TZS 10,000",
  sw: "Kiwango cha chini ni TZS 10,000",
}

export const STR_BACK = {
  en: "Back",
  sw: "Rudi",
}

export const STR_YOUR_REQUEST = {
  en: "Your Request",
  sw: "Ombi Lako",
}

export const STR_VIEW_AGENT_PROFILE = {
  en: "View Agent's Profile",
  sw: "Ona Wasifu wa Wakala",
}

export const STR_SEND_MESSAGE_TO_AGENT = {
  en: "Send Message To Agent",
  sw: "Tuma Ujumbe kwa Wakala",
}

export const STR_CLOSE_REQUEST = {
  en: "Close this Request",
  sw: "Funga Ombi hili",
}

export const STR_NO_MESSAGES = {
  en: "No messages",
  sw: "Hakuna ujumbe kwa sasa",
}

export const STR_SEARCH_HERE = {
  en: "Search here",
  sw: "Tafuta hapa",
}

export const STR_NEW = {
  en: "New",
  sw: "Mpya",
}

export const STR_COULD_NOT_PROCESS_REQUEST = {
  en: "Could not process request",
  sw: "Imeshindwa kuchakata ombi lako",
}

export const STR_NO_AGENT_FOUND = {
  en: "No agent was found",
  sw: "Hakuna wakala kwa sasa",
}

export const STR_YOUR_REPORTS = {
  en: "Your Reports",
  sw: "Ripoti Zako",
}

export const STR_CREATE_REPORT = {
  en: "Create Report",
  sw: "Tengeneza Ripoti",
}

export const STR_REPORT_FOR = {
  en: "Report For",
  sw: "Ripoti Kwa ajili ya",
}

export const STR_REPORT_TYPE = {
  en: "Report Type",
  sw: "Aina ya Ripoti",
}

export const STR_CLOSING_BALANCE = {
  en: "Closing Balance",
  sw: "Salio la Kufungia",
}

export const STR_OPENING_BALANCE = {
  en: "Opening Balance",
  sw: "Salio la Kufungulia",
}

export const STR_PAYABLE = {
  en: "Payables",
  sw: "Madeni Ninayodaiwa",
}

export const STR_RECEIVABLE = {
  en: "Receivables",
  sw: "Madeni Ninayodai",
}

export const STR_REPORT_DATE = {
  en: "Report's Date",
  sw: "Tarehe ya Ripoti",
}

export const STR_PHOTO_EVIDENCE = {
  en: "Image Evidence",
  sw: "Ushahidi wa Picha",
}

export const STR_AGENT_REPORT = {
  en: "Agent's Report",
  sw: "Ripoti ya Wakala",
}

export const STR_CREATE_PIN_TO_SECURE_ACCOUNT = {
  en: "Create a PIN to secure your Account",
  sw: "Tengeneza PIN ili kulinda Akaunti yako",
}

export const STR_ENTER_PIN = {
  en: "Enter PIN",
  sw: "Ingiza PIN",
}

export const STR_CONFIRM_PIN = {
  en: "Confirm PIN",
  sw: "Thibitisha PIN",
}

export const STR_INVALID_PIN = {
  en: "Invalid PIN. 4 Digits required",
  sw: "PIN sio sahihi. Zinahitajika namba 4",
}

export const STR_INCORRECT_PIN = {
  en: "Incorrect PIN",
  sw: "PIN sio sahihi",
}

export const STR_CONFIRM_PIN_CORRECTLY = {
  en: "Confirm PIN Correctly",
  sw: "Thibitisha PIN kwa usahihi",
}

export const STR_CURRENT_PARTICIPANTS_COUNT = {
  en: "Number of participants at this time",
  sw: "Idadi ya washiriki kwa sasa",
}

export const STR_REQUEST_SECRET_CODE = {
  en: "Request Secret Code",
  sw: "Msimbo Siri wa Ombi",
}

export const STR_CONFIRM_PROCESSING = {
  en: "Confirm Processing",
  sw: "Thibitisha Kukamilisha ombi",
}

export const STR_PLEASE_PROVIDE_SECRET_CODE = {
  en: "Please provide secret code",
  sw: "Tafadhali ingiza msimbo siri",
}

export const STR_REQUEST_WAS_CLOSED = {
  en: "Request was closed",
  sw: "Ombi limefungwa",
}

export const STR_MY_CREATED_AGENT_REQUESTS = {
  en: "Requests Created By Me",
  sw: "Maombi Niliotuma",
}

export const STR_MY_PROCESSED_AGENT_REQUESTS = {
  en: "Requests Processed By Me",
  sw: "Maombi Niliokamilisha",
}

export const STR_MY_PARTICIPATED_AGENT_REQUESTS = {
  en: "Requests I've Participated in",
  sw: "Maombi Nilioshiriki",
}

export const STR_AGENT_REQUESTS_HISTORY = {
  en: "Requests History",
  sw: "Historia ya Maombi",
}

export const STR_OTHER_SETTINGS = {
  en: "Other Settings",
  sw: "Mipangilio Mingine",
}

export const STR_AGENCY_REPORTS = {
  en: "Agency Reports",
  sw: "Ripoti za Kiuwakala",
}

export const STR_INVALID_REPORT = {
  en: "Invalid report",
  sw: "Ripoti sio sahihi",
}

export const STR_TOTAL_2 = {
  en: "Total",
  sw: "Jumla",
}

export const STR_COMMISSIONS_REPORT = {
  en: "Commissions Report",
  sw: "Ripoti ya Kamisheni",
}

export const STR_LINK_SUPERVISOR = {
  en: "Link Supervisor",
  sw: "Unganisha Msimamizi",
}

export const STR_SUPERVISOR_PHONE = {
  en: "Supervisor's Phone",
  sw: "Namba ya simu ya msimamizi",
}

export const STR_REPORTS = {
  en: "Reports",
  sw: "Ripoti",
}

export const STR_NAME_OR_COMPANY = {
  en: "Name or Company",
  sw: "Jina au Kampuni",
}

export const STR_NET_TOTAL = {
  en: "Net Total",
  sw: "Jumla Kuu",
}

export const STR_SUB_TOTAL = {
  en: "Sub Total",
  sw: "Jumla",
}

export const STR_PAY_NOW = {
  en: "Pay Now",
  sw: "Lipia Sasa",
}

export const STR_GOLD = {
  en: "Gold",
  sw: "Dhahabu",
}

export const STR_PLATNUM = {
  en: "Platnum",
  sw: "Platnum",
}

export const STR_NORMAL = {
  en: "Normal",
  sw: "Kawaida",
}

export const STR_VERIFY_YOUR_PROFILE = {
  en: "Verify Your Profile",
  sw: "Thibitisha Wasifu Wako",
}

export const STR_UPLOAD_TIN_CERTIFICATE = {
  en: "Upload a copy of your TIN Certificate",
  sw: "Pakia nakala ya Hati ya TIN",
}

export const STR_UPLOAD_NIDA_ID_COPY_FRONT = {
  en: "Upload a front copy of your NIDA ID Card",
  sw: "Pakia nakala ya mbele ya kitambulisho chako cha NIDA",
}

export const STR_UPLOAD_NIDA_ID_COPY_BACK = {
  en: "Upload a back copy of your NIDA ID Card",
  sw: "Pakia nakala ya nyuma ya kitambulisho chako cha NIDA",
}

export const STR_UPLOAD_BUSINESS_LICENSE = {
  en: "Upload copy of your business license",
  sw: "Pakia nakala ya leseni yako ya biashara",
}

export const STR_PLEASE_UPLOAD_ALL_REQUESTED_FILES = {
  en: "Please upload all requested files",
  sw: "Tafadhali pakia faili zote zinazotakiwa",
}

export const STR_YOU_WERE_VERIFIED = {
  en: "Your profile was Verified",
  sw: "Wasifu wako umethibitishwa",
}

export const STR_YOU_HAVE_SUBMITTED_AGENT_VERIFICATION_REQUEST = {
  en: "You have submitted agent verification request, please wait for our feedback.",
  sw: "Umewasilisha ombi lako la kuthibitisha wasifu, tafadhali subiri majibu yetu.",
}

export const STR_FLOAT_LOAN_SERVICE = {
  en: "Float Loan Service",
  sw: "Huduma ya Mkopo wa Floti",
}

export const STR_REQUEST_LOAN = {
  en: "Request Loan",
  sw: "Omba Mkopo",
}

export const STR_FLOAT_LOAN_BALANCE = {
  en: "Float Loan Balance",
  sw: "Salio la Mkopo",
}

export const STR_FLOAT_LOAN_LIMIT = {
  en: "FLoat Loan Limit",
  sw: "Kikomo cha Kukopa",
}

export const STR_INVALID_TILL = {
  en: "Invalid TILL",
  sw: "Till sio sahihi",
}

export const STR_MY_LOANS = {
  en: "My Loans",
  sw: "Mikopo Yangu",
}

export const STR_REQUESTED_AMOUNT = {
  en: "Requested Amount",
  sw: "Kiasi kilichoombwa",
}

export const STR_LOANED_AMOUNT = {
  en: "Loaned Amount",
  sw: "Kiasi kilichotolewa",
}

export const STR_REPAID_AMOUNT = {
  en: "Repaid Amount",
  sw: "Kiasi kilichorejeshwa",
}

export const STR_IS_LOANED = {
  en: "Is Loaned?",
  sw: "Imekopeshwa?",
}

export const STR_IS_REPAID = {
  en: "Is Repaid?",
  sw: "Imerejeshwa?",
}

export const STR_IS_REJECTED = {
  en: "Is Rejected?",
  sw: "Imekataliwa?",
}

export const STR_REQUESTED_DATE = {
  en: "Requested On",
  sw: "Muda wa kuomba",
}

export const STR_EXPECTED_REPAY_DATE = {
  en: "To be repaid before",
  sw: "Inapaswa kurejeshwa kabla ya",
}

export const STR_REPAID_DATE = {
  en: "Repaid On",
  sw: "Muda wa kurejeshwa",
}

export const STR_PENDING = {
  en: "Pending",
  sw: "Inasubiri",
}

export const STR_REJECTED = {
  en: "Rejected",
  sw: "Imekataliwa",
}

export const STR_PROCESSED = {
  en: "Processed",
  sw: "Imefanyiwa Kazi",
}

export const STR_BY_SENDING_LOAN_REQUEST_YOU_AGREE_TO_TERMS = {
  en: "By sending float loan request you agree to our terms and conditions for this service",
  sw: "Kwa kutuma ombi la mkopo wa floti unakubaliana na vigezo na masharti vya huduma hii",
}

export const STR_FLOAT_LOAN_TERMS = {
  en: "Float Loan Service Terms & Conditions",
  sw: "Vigezo na Masharti vya huduma ya Mkopo wa Floti",
}

export const STR_READ_TERMS_CONDITIONS = {
  en: "Read Terms & Conditions",
  sw: "Soma Vigezo na Masharti",
}

export const STR_MENU_POST_CROPS = {
  en: "Post Crops",
  sw: "Weka Mazao",
}

export const STR_MENU_MY_SALES = {
  en: "My Sales",
  sw: "Mauzo Yangu",
}

export const STR_MENU_MY_PURCHASES = {
  en: "My Purchases",
  sw: "Manunuzi Yangu",
}

export const STR_RECENT_CROPS = {
  en: "Recently Posted Crops",
  sw: "Mazao Yaliowekwa Hivi Karibuni",
}

export const STR_POST_ITEM = {
  en: "Post Item",
  sw: "Weka Bidhaa",
}

export const STR_ITEM_TITLE = {
  en: "Item Title",
  sw: "Jina la Bidhaa",
}

export const STR_INVALID_ITEM_TITLE = {
  en: "Invalid item title",
  sw: "Jina la bidhaa sio sahihi",
}

export const STR_ITEM_DESCRIPTION = {
  en: "Item Description",
  sw: "Maelezo kuhusu bidhaa",
}

export const STR_INVALID_ITEM_DESCRIPTION = {
  en: "Invalid item description",
  sw: "Maelezo kuhusu bidhaa sio sahihi",
}

export const STR_ITEM_CATEGORY = {
  en: "Item Category",
  sw: "Aina ya Bidhaa",
}

export const STR_CROPS = {
  en: "Crops",
  sw: "Mazao",
}

export const STR_LIVESTOCK = {
  en: "Livestock",
  sw: "Mifugo",
}

export const STR_UNIT_PRICE = {
  en: "Unit Price in TZS",
  sw: "Bei kwa moja/kipimo kwa TZS",
}

export const STR_INVALID_UNIT_PRICE = {
  en: "Invalid unit price",
  sw: "Bei sio sahihi",
}

export const STR_UNIT = {
  en: "Unit",
  sw: "Kipimo",
}

export const STR_INVALID_UNIT = {
  en: "Invalid unit",
  sw: "Kipimo sio sahihi",
}

export const STR_AVAILABLE_QUANTITY = {
  en: "Total Available Quantity",
  sw: "Jumla ya Kiasi Kinachopatikana",
}

export const STR_INVALID_QUANTITY = {
  en: "Invalid Quantity",
  sw: "Kiasi sio sahihi",
}


export const STR_MOQ = {
  en: "Minimum Order Quantity",
  sw: "Kiasi cha chini cha mteja kuagiza",
}

export const STR_ITEM_LOCATION = {
  en: "Item's Location",
  sw: "Mahali bidhaa ilipo",
}

export const STR_INVALID_LOCATION = {
  en: "Invalid Location",
  sw: "Mahali sio sahihi",
}

export const STR_IMAGES = {
  en: "Images",
  sw: "Picha",
}

export const STR_AT_LEAST_ONE_IMAGE = {
  en: "Please provide atleast one image",
  sw: "Tafadhali weka angalau picha moja",
}

export const STR_RECENT_ITEMS = {
  en: "Recent Items",
  sw: "Bidhaa za Hivi Karibuni",
}

export const STR_PLACE_ORDER = {
  en: "Place Order",
  sw: "Weka Oda",
}

export const STR_PLACE_YOUR_ORDER = {
  en: "Place Your Order",
  sw: "Weka Oda Yako",
}

export const STR_ORDER_QUANTITY = {
  en: "Order Quantity",
  sw: "Kiasi unachoagiza",
}

export const STR_ORDER_NOTES = {
  en: "Order Notes",
  sw: "Maelekezo ya oda",
}

export const STR_DELIVERY_LOCATION = {
  en: "Delivery Location",
  sw: "Mahali pa kufikishia mzigo",
}

export const STR_TOTAL_ORDER_PRICE = {
  en: "Total Items Price",
  sw: "Jumla ya bei ya bidhaa",
}

export const STR_TRANSACTION_FEES = {
  en: "Transaction fees",
  sw: "Tozo za muamala",
}

export const STR_SHIPPING_COST = {
  en: "Shipping Cost",
  sw: "Gharama za usafirishaji",
}

export const STR_PACKAGING_COST = {
  en: "Packaging Cost",
  sw: "Gharama za vifungashio",
}

export const STR_OVERALL_COST = {
  en: "Overall Cost",
  sw: "Jumla Kuu",
}

export const STR_SELLER = {
  en: "Seller",
  sw: "Muuzaji",
}


export const STR_ORDER_STATUS = {
  en: "Order Status",
  sw: "Hali ya Oda",
};

export const STR_ORDERED_ITEM = {
  en: "Ordered Item",
  sw: "Bidhaa ilioagizwa",
}

export const STR_ORDERED_QUANTITY = {
  en: "Ordered Quantity",
  sw: "Kiasi Kilichoagizwa",
}

export const STR_RECEIPT = {
  en: "Receipt",
  sw: "Risiti",
}

export const STR_UNPAID = {
  en: "Unpaid",
  sw: "Haijalipiwa",
}

export const STR_PARTIALLY_PAID = {
  en: "Partially Paid",
  sw: "Imelipiwa Kiasi",
}

export const STR_FULLY_PAID = {
  en: "Paid",
  sw: "Imelipiwa",
}

export const STR_PAYMENT_STATUS = {
  en: "Payment Status",
  sw: "Hali ya Malipo",
}

export const STR_CUSTOMER_NAME = {
  en: "Customer's Name",
  sw: "Jina la Mteja",
}

export const STR_CUSTOMER_PHONE = {
  en: "Customer's Phone",
  sw: "Simu ya Mteja",
}

export const STR_IS_SHIPPED = {
  en: "Is Shipped?",
  sw: "Imesafirishwa?",
}

export const STR_IS_DELIVERED = {
  en: "Is Delivered?",
  sw: "Imefikishwa?",
}

export const STR_IS_CANCELLED = {
  en: "Is Cancelled?",
  sw: "Imesitishwa?",
}

export const STR_IS_CONFIRMED = {
  en: "Is Confirmed",
  sw: "Imekubaliwa?",
}

export const STR_CANCELLATION_REASON = {
  en: "Cancellation Reason",
  sw: "Sababu ya kusitisha",
}

export const STR_CANCEL_ORDER = {
  en: "Cancel this order",
  sw: "Sitisha oda hii",
}

export const STR_INVALID_REASON = {
  en: "Invalid reason",
  sw: "Weka sababu",
}

export const STR_MY_REVENUES = {
  en: "My Revenue",
  sw: "Mapato Yangu",
}

export const STR_CURRENT_BALANCE = {
  en: "Current Balance",
  sw: "Salio Liliopo",
}

export const STR_SEND_WITHDRAWAL_REQUEST = {
  en: "Send Withdrawal Request",
  sw: "Tuma Ombi la Kutoa Pesa",
}

export const STR_MY_WITHDRAWAL_REQUESTS = {
  en: "My Withdrawal Requests",
  sw: "Maombi Yangu ya Kutoa Pesa",
}

export const STR_MY_WITHDRAWALS = {
  en: "My Withdrawals",
  sw: "Historia Ya Kutoa Pesa",
}

export const STR_MY_EARNINGS_HISTORY = {
  en: "My Earnings History",
  sw: "Mapato Niliotengeneza",
}

export const STR_WITHDRAWAL_AMOUNT = {
  en: "Amount to Withdraw",
  sw: "Kiasi cha kutoa",
}

export const STR_WITHDRAWAL_METHOD = {
  en: "Withdrawal Method",
  sw: "Njia Utakayopokelea Pesa",
}

export const STR_WITHDRAWAL_ACCOUNT_NAME = {
  en: "Withdrawal Account/Phone Name",
  sw: "Jina la Akaunti/Namba ya Simu Utakayopokelea",
}

export const STR_WITHDRAWAL_ACCOUNT_NUMBER = {
  en: "Withdrawal Account/Phone Number",
  sw: "Namba ya Akaunti/Simu Utakayopokelea",
}

export const STR_INVALID_WITHDAWAL_INFO = {
  en: "Invalid Withdrawal Information",
  sw: "Jaza kikamilifu taarifa za kutolea pesa",
}

export const STR_STATUS = {
  en: "Status",
  sw: "Hali",
}

export const STR_VIEW_SALE = {
  en: "View Sale",
  sw: "Ona Mauzo",
}

export const STR_VIEW_WITHDRAWAL_REQUEST = {
  en: "View Withdrawal Request",
  sw: "Ona Ombi la Kutoa Pesa",
}

export const STR_ORDER_PAYMENTS = {
  en: "Order Payments",
  sw: "Malipo ya Oda",
}

export const STR_TOTAL_PAID = {
  en: "Total Paid",
  sw: "Jumla Iliolipwa",
}

export const STR_OUTSTANDING_BALANCE = {
  en: "Outstanding Balance",
  sw: "Salio Liliobakia",
}

export const STR_MENU_SHOP = {
  en: "Shop",
  sw: "Duka",
}

export const STR_CREATE_POST = {
  en: "Create Post",
  sw: "Weka Picha",
}

export const STR_PASTORS = {
  en: "Pastors",
  sw: "Wachungaji",
}

export const STR_DONATIONS = {
  en: "Donations",
  sw: "Michango",
}

export const STR_MY_ORDERS = {
  en: "My Orders",
  sw: "Oda Zangu",
}

export const STR_MY_WISHLIST = {
  en: "My Wishlist",
  sw: "Vipendeleo",
}

export const STR_MENU_SCAN = {
  en: "Map Land",
  sw: "Pima Ardhi",
}

export const STR_MENU_INQUIRIES = {
  en: "Inquiries",
  sw: "Maulizo",
}

export const STR_INQUIRY_DETAILS = {
  en: "Inquiry Details",
  sw: "Maelezo ya Ombi",
}

export const STR_AREA = {
  en: "Area",
  sw: "Eneo",
}

export const STR_PERIMETER = {
  en: "Perimeter",
  sw: "Mzunguko",
}

export const STR_LINE_LENGTH = {
  en: "Line Length",
  sw: "Urefu wa Mstari",
}

export const STR_MAPPING_TYPE = {
  en: "Mapping Type",
  sw: "Aina ya Upimaji",
}

export const STR_POLYLINE = {
  en: "Road / Line",
  sw: "Barabara / Mstari",
}

export const STR_LAND_POLYGON = {
  en: "Land Polygon",
  sw: "Poligoni ya Ardhi",
}

export const STR_LOCATION = {
  en: "Location",
  sw: "Mahali",
}

export const STR_SERVICES = {
  en: "Requested Services",
  sw: "Huduma Zilizoombwa",
}

export const STR_CORNER_POINTS = {
  en: "Selected Points",
  sw: "Pointi Zilizochaguliwa",
}

export const STR_SELECTED_GEOMETRY = {
  en: "Selected Area / Line",
  sw: "Eneo / Mstari Uliochaguliwa",
}

export const STR_COPY = {
  en: "Copy",
  sw: "Nakili",
}

export const STR_COORDINATE_COPIED = {
  en: "Coordinate copied",
  sw: "Kuratibu imenakiliwa",
}

export const STR_COPY_FAILED = {
  en: "Could not copy coordinate",
  sw: "Imeshindikana kunakili kuratibu",
}

export const STR_COORDINATE_FORMATS = {
  en: "Coordinate Formats",
  sw: "Miundo ya Kuratibu",
}

export const STR_LATITUDE_LONGITUDE = {
  en: "Latitude / Longitude",
  sw: "Latitudo / Longitudo",
}

export const STR_EASTING_NORTHING = {
  en: "Easting / Northing",
  sw: "Mashariki / Kaskazini",
}

export const STR_EASTING = {
  en: "Easting",
  sw: "Mashariki",
}

export const STR_NORTHING = {
  en: "Northing",
  sw: "Kaskazini",
}

export const STR_SOURCE_CRS = {
  en: "Source CRS",
  sw: "Mfumo Chanzo wa Kuratibu",
}

export const STR_MOBILE_GPS = {
  en: "Mobile GPS",
  sw: "GPS ya Simu",
}

export const STR_MAPPING_METHOD = {
  en: "How do you want to map the points?",
  sw: "Unataka kupima pointi kwa njia gani?",
}

export const STR_MOBILE_GPS_MAPPING = {
  en: "Mobile GPS Mapping",
  sw: "Upimaji kwa GPS ya Simu",
}

export const STR_MANUAL_IMPORTATION = {
  en: "Manual Point Importation",
  sw: "Kuingiza Pointi Mwenyewe",
}

export const STR_COORDINATE_DATUM = {
  en: "Coordinate Datum",
  sw: "Datum ya Kuratibu",
}

export const STR_DECIMAL_COORDINATE_HELP = {
  en: "Enter signed decimal degrees. Southern latitude is negative and eastern longitude is positive. Add points in boundary or line order.",
  sw: "Weka digrii za desimali zenye alama. Latitudo ya kusini ni hasi na longitudo ya mashariki ni chanya. Weka pointi kwa mpangilio wa mpaka au mstari.",
}

export const STR_ADD_POINT = {
  en: "Add Point",
  sw: "Ongeza Pointi",
}

export const STR_REMOVE = {
  en: "Remove",
  sw: "Ondoa",
}

export const STR_MOVE_UP = {
  en: "Move Up",
  sw: "Peleka Juu",
}

export const STR_MOVE_DOWN = {
  en: "Move Down",
  sw: "Peleka Chini",
}

export const STR_LATITUDE = {
  en: "Latitude",
  sw: "Latitudo",
}

export const STR_LONGITUDE = {
  en: "Longitude",
  sw: "Longitudo",
}

export const STR_SOURCE_REFERENCE = {
  en: "Source Map / Document Reference (Optional)",
  sw: "Rejea ya Ramani / Hati Chanzo (Si Lazima)",
}

export const STR_ORIGINAL_UTM_ZONE = {
  en: "Original UTM Zone, If Shown (Optional)",
  sw: "Ukanda wa UTM wa Awali, Kama Umeonyeshwa (Si Lazima)",
}

export const STR_ARC1960_WARNING = {
  en: "Arc 1960 points will be normalized to WGS 84 for mapping using the Tanzania EPSG:1285 transformation. The original values will also be preserved.",
  sw: "Pointi za Arc 1960 zitabadilishwa kuwa WGS 84 kwa ajili ya ramani kwa kutumia badiliko la Tanzania EPSG:1285. Thamani za awali pia zitahifadhiwa.",
}

export const STR_MANUAL_POINTS_INVALID = {
  en: "Add at least two complete, valid and distinct points.",
  sw: "Ongeza angalau pointi mbili kamili, sahihi na tofauti.",
}

export const STR_MAPPING_SOURCE = {
  en: "Point Mapping Source",
  sw: "Chanzo cha Upimaji wa Pointi",
}

export const STR_NORMALIZED_COORDINATES = {
  en: "Normalized WGS 84 Coordinates",
  sw: "Kuratibu Zilizobadilishwa kuwa WGS 84",
}

export const STR_ORIGINAL_COORDINATES = {
  en: "Original Entered Coordinates",
  sw: "Kuratibu za Awali Zilizoingizwa",
}

export const STR_SQUARE_METERS = {
  en: "Square Meters",
  sw: "Mita za Mraba",
}

export const STR_METERS = {
  en: "Meters",
  sw: "Mita",
}

export const STR_NO_SERVICES_FOUND = {
  en: "No services were found",
  sw: "Hakuna huduma zilizopatikana",
}

export const STR_SEND_LAND_INQUIRY = {
  en: "Send Inquiry for the Selected Land",
  sw: "Tuma Ombi kwa Ardhi Iliyochaguliwa",
}

export const STR_INQUIRY_RECEIVED = {
  en: "Your inquiry was received. Thank you.",
  sw: "Ombi lako limepokelewa. Asante.",
}

export const STR_VIEW_MY_INQUIRIES = {
  en: "View My Inquiries",
  sw: "Ona Maombi Yangu",
}

export const STR_ = {
  en: "",
  sw: "",
}
